import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@mui/material';

const useStyles = makeStyles(theme => ({
  textContainer: {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: 40,
    marginTop: '10px',
    backgroundColor: '#f0f0f0'
  },
  text: {
    position: 'absolute',
    top: 0,
    whiteSpace: 'nowrap',
    animation: '$moveText 90s linear infinite',
    right: '10%',
    animationDelay: '0s',
  },
  '@keyframes moveText': {
    '0%': {
      transform: 'translateX(100%)',
    },
    '100%': {
      transform: 'translateX(-200%)',
    },
  },
}));

function NewsTicker({ isUdFlow, textForNews }) {
  const classes = useStyles();

  return (
    <div className={classes.textContainer}>
      <Typography
        variant="body1"
        className={classes.text}
        style={{ padding: '10px', color: isUdFlow ? '#36454F' : '#1F4A7C', fontWeight: 'bold', fontSize: '15px' }}
      >
        {textForNews}
      </Typography>
    </div>
  );
}

export default NewsTicker